module.exports = __webpack_public_path__ + "img/laboratorio3_4-3_682.d635bdfe.webp";